// 神策初始化fun
declare global {
  interface Window {
    sensors: any
    sensorsDataAnalytic201505: any
  }
}

export function initSensors() {
  const sensors = window['sensorsDataAnalytic201505'] as any
  window.sensors = sensors

  // 初始化神策分析
  sensors.init({
    show_log: false,
    server_url:
      window.location.origin.indexOf('mi.jzsec.com') !== -1
        ? 'https://sa-api.chtfund.com/sa?project=ht_scsdk_online'
        : 'https://sa-api.chtfund.com/sa?project=default',
    app_js_bridge: true,
    is_track_single_page: false,
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      // default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。采集 a、button、input 、textarea 标签
      clickmap: 'default',
      // default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭。
      scroll_notice_map: 'default',
      collect_tags: {
        div: true, // 开启div标签的点击事件埋点采集
      },
    },
  })

  // 注册页面信息
  sensors.registerPage({
    platform: 'huayuan',
    dataSource: '',
  })

  // 自动追踪页面事件
  sensors.quick('autoTrack')

  // 使用页面加载时长和页面浏览时长插件
  sensors.use('PageLoad') // 页面加载时长
  sensors.use('PageLeave') // 页面浏览时长
}
